"use client"

import { Images } from "@/constants/images"
import { useNotificationMessages } from "@/lib/useNotificationMessages"
import Image from "next/image"

interface SocialListProps {
  currentUrl: string
  currentTitle: string
}

const SocialList = ({ currentUrl, currentTitle }: SocialListProps) => {
  const { successNotification } = useNotificationMessages()

  const socialMediaLinks = [
    {
      onClick: (e: React.MouseEvent) => {
        e.preventDefault()
        navigator.clipboard.writeText(window.location.href).then(() => {
          successNotification("Link copied to clipboard!")
        })
      },
      icon: Images.iconLink,
      alt: "Copy Link",
      isClickable: true,
    },
    {
      href: `https://www.facebook.com/sharer/sharer.php?u=${currentUrl}`,
      icon: Images.facebookFill,
      alt: "Facebook",
    },
    {
      href: `https://www.linkedin.com/sharing/share-offsite/?url=${currentUrl}`,
      icon: Images.iconLinkedin,
      alt: "LinkedIn",
    },
    {
      href: `https://twitter.com/intent/tweet?url=${currentUrl}&text=${currentTitle}`,
      icon: Images.iconTwitter,
      alt: "Twitter",
    },
    {
      href: "https://www.instagram.com/caocaoadventures_cycling_tours/",
      icon: Images.instagramFill,
      alt: "Instagram",
    },
  ]

  return (
    <div className="flex flex-row items-center gap-3">
      {socialMediaLinks.map((social, index) =>
        social.isClickable ? (
          <div
            key={index}
            onClick={social.onClick}
            className="h-10 w-10 min-w-10 min-h-10 flex items-center justify-center rounded-full bg-white border border-[#E5E5EA] hover:drop-shadow-lg duration-300 hover:cursor-pointer"
          >
            <Image src={social.icon} alt={social.alt} width={20} height={20} className="" />
          </div>
        ) : (
          <a
            key={index}
            href={social.href}
            target="_blank"
            rel="noopener noreferrer"
            className="h-10 w-10 min-w-10 min-h-10 flex items-center justify-center rounded-full bg-white border border-[#E5E5EA] hover:drop-shadow-lg duration-300 hover:cursor-pointer"
          >
            <Image src={social.icon} alt={social.alt} width={20} height={20} />
          </a>
        ),
      )}
    </div>
  )
}

export default SocialList
